export default __webpack_public_path__ + "static/media/services_decor.5ed8dabf.jpg";